function addAnimateIntoView() {
	let animIntoViewElements = document.querySelectorAll('[data-animate="true"]');

	gsap.registerPlugin(ScrollTrigger);
	for (const animElement of animIntoViewElements) {
		let animDirection = animElement.getAttribute('data-anim_direction');
		let animDuration = animElement.getAttribute('data-anim_duration');
		let animDelay = animElement.getAttribute('data-anim_delay');

		let animType = animElement.getAttribute('data-anim_type');
		let customExpression = animElement.getAttribute('data-anim_custom');

		if (null === animDuration) {
			animDuration = 400;
		}
		if (null === animDelay) {
			animDuration = 0;
		}
		//We need to get element settings here
		let animStartArray = {};
		let customExpressionArray = {}
		animStartArray.opacity = 0;
		let rotateValue = 0;
		let moveValue = 0;
		let useCustomExpression = false;
		let json ={}
		switch (animType) {
			case 'flip-in':
				rotateValue = 90;
			break;
			case 'slide-in':
				moveValue = 100;
				rotateValue = 0;
			break;
			case 'custom':
				useCustomExpression = true;
				//customExpressionArray = customExpression;

				customExpression = customExpression.split(",");
				for (var i = 0; i < customExpression.length; i++) {
					let keyvalue = customExpression[i].split(":");
					customExpressionArray[keyvalue[0].trim()] = keyvalue[1].trim();
				}


				break;

		}

		switch (animDirection) {
			case 'right':
				animStartArray.x = moveValue;
				animStartArray.rotateY = rotateValue
				animElement.style.transformOrigin = 'left';
			break;
			case 'left':
				animStartArray.x = -moveValue;
				animStartArray.rotateY = -rotateValue
				animElement.style.transformOrigin = 'right';

				break;
			case 'bottom':
				animStartArray.y = moveValue;
				animStartArray.rotateX = -rotateValue
				animElement.style.transformOrigin = 'top';

				break;
			case 'top':
				animStartArray.y = -moveValue;
				animStartArray.rotateX = rotateValue
				animElement.style.transformOrigin = 'bottom';

				break;
		}

		if (useCustomExpression) {
			animStartArray =  customExpressionArray;
		}

		//If element already visible on screen, do not animate
		if (true !== elementIsVisibleInViewport(animElement, true)) {
			gsap.set(animElement, animStartArray );
			gsap.to(animElement, {
				opacity: 1,
				rotateX: 0,
				rotateY: 0,
				x: 0,
				y: 0,
				duration: animDuration/1000,
				delay: animDelay/1000,
				ease: 'ease.inOut',
				scrollTrigger: {
					trigger: animElement,
					start: "top 75%",
					end: "top center",
					scrub: false,
					markers: false,
				}
			});
		}
	}
}

const elementIsVisibleInViewport = (el, partiallyVisible = false) => {
	const { top, left, bottom, right } = el.getBoundingClientRect();
	const { innerHeight, innerWidth } = window;
	return partiallyVisible
		? ((top > 0 && top < innerHeight) ||
			(bottom > 0 && bottom < innerHeight)) &&
		((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
		: top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
};

document.addEventListener("DOMContentLoaded", function(event) {
	if ('undefined' === typeof gsap) {
		console.log('GSAP library not loaded.');
	} else {
		addAnimateIntoView();
	}
});
